import React, { useEffect, useState } from 'react';

// URL de la mascotte qui réfléchit
const MASCOT_THINKING_URL = 'https://customer-assets.emergentagent.com/job_dialogue-digest-1/artifacts/34459ulw_image.png';

const LoadingQuestionModal = ({ isVisible, childName, question }) => {
  const [progress, setProgress] = useState(0);

  // Animation de la barre de progression en boucle
  useEffect(() => {
    if (!isVisible) {
      setProgress(0);
      return;
    }

    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) return 0;
        return prev + 2;
      });
    }, 40); // 2000ms pour 0-100%

    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div 
        className="bg-white rounded-3xl p-6 max-w-[350px] w-full text-center relative"
        style={{ boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)' }}
      >
        {/* Mascotte qui dépasse en haut */}
        <div className="flex justify-center" style={{ marginTop: '-80px', marginBottom: '15px' }}>
          <img 
            src={MASCOT_THINKING_URL}
            alt="Mascotte qui réfléchit"
            className="w-[130px] h-[150px] object-contain"
            style={{ filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.15))' }}
          />
        </div>

        {/* Titre */}
        <h2 
          className="text-2xl font-bold mb-2"
          style={{ fontFamily: '"Caveat", cursive', color: '#333333' }}
        >
          Génial {childName} ! Laisse-moi réfléchir !
        </h2>

        {/* Sous-titre */}
        <p className="text-base mb-5" style={{ color: '#4A90A4' }}>
          Je prépare une réponse parfaite...
        </p>

        {/* Barre de progression */}
        <div 
          className="w-full h-[10px] rounded-full mb-5 overflow-hidden"
          style={{ backgroundColor: '#E8E8E8' }}
        >
          <div 
            className="h-full rounded-full transition-all duration-100"
            style={{ 
              width: `${progress}%`,
              background: 'linear-gradient(90deg, #4A90A4 0%, #6BB5A2 100%)'
            }}
          />
        </div>

        {/* Question box */}
        <div 
          className="rounded-2xl p-4 w-full"
          style={{ backgroundColor: '#F5F5F5' }}
        >
          <p 
            className="text-lg mb-1"
            style={{ fontFamily: '"Caveat", cursive', color: '#4A90A4' }}
          >
            Ta question :
          </p>
          <p 
            className="text-xl text-center"
            style={{ fontFamily: '"Caveat", cursive', color: '#333333' }}
          >
            "{question}"
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingQuestionModal;
